




































import { Vue, Component } from 'vue-property-decorator'
import { ExStore } from 'vuex'
import { Worker, Patient, Relative } from '@/types/user'

@Component({
  components: {
    UserSearchForm: () => import('@/components/common/UserSearchForm.vue'),
    CallTeamList: () => import('@/components/call/CallTeamList.vue'),
    CallUserList: () => import('@/components/call/CallUserList.vue'),
    Loading: () => import('@/components/common/loadings/Index.vue')
  }
})
export default class CallUserSearch extends Vue {
  $store!: ExStore
  users: (Worker | Patient)[] = []
  isSearch = false
  isLoading = false

  get callPartnerNames() {
    return this.callPartners
      .map(user => `${user.lastName}${user.firstName}`)
      .join('、')
  }

  get callPartners() {
    return this.$store.getters['call/callPartners']
  }

  get showResults() {
    return this.isSearch && !!this.users.length && !this.isLoading
  }

  get showNoResults() {
    return this.isSearch && !this.users.length && !this.isLoading
  }

  onChange() {
    this.isSearch = true
    this.isLoading = true
  }

  onUpdateUser(users: (Worker | Patient)[]) {
    this.users = users
    this.isLoading = false
  }

  handleClickCallButton() {
    if (this.callPartners.length === 0) {
      // TODO: バリデーションメッセージ
      return
    }

    this.$store.dispatch('videoCallRoom/call', { users: this.callPartners })
    this.$store.dispatch('call/displayUserselectModal', false)
  }
}
